import { configureStore } from '@reduxjs/toolkit'
import { reducer as corpInfoReducer } from './corp-info'
import { reducer as corpSettingReducer } from './corp-setting'
import { reducer as cartReducer } from './cart'

export const store = configureStore({
  reducer: {
    corpInfo: corpInfoReducer,
    corpSetting: corpSettingReducer,
    cart: cartReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch